import React from 'react';
import { Link } from 'react-router-dom';
import './not-found.css';

const NotFound: React.FC = () => {
  return (
    <div className="space-container">
      {/* Fondo de estrellas generado por CSS */}
      <div className="stars"></div>
      <div className="twinkling"></div>

      <div className="content-box">
        <div className="planet-container">
          <div className="planet-bg"></div>
          {/* Texto gigante 404 detrás del astronauta */}
          <h1 className="giant-404">404</h1>
        </div>

        {/* SVG del Astronauta flotando */}
        <div className="astronaut-box">
          <svg className="astronaut-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
             <path className="astro-body" fill="#fff" d="M30,50 Q30,30 50,30 Q70,30 70,50 L70,80 Q70,90 60,90 L40,90 Q30,90 30,80 Z" />
             <circle className="astro-head" cx="50" cy="50" r="15" fill="#333" />
             <path className="astro-glass" fill="rgba(100, 200, 255, 0.5)" d="M40,45 Q50,40 60,45 Q62,50 60,55 Q50,60 40,55 Q38,50 40,45 Z" />
             <path className="astro-pack" fill="#ddd" d="M25,50 L30,50 L30,80 L25,80 Q20,80 20,65 Q20,50 25,50 Z" />
             <path className="astro-arm-l" fill="#fff" d="M30,55 Q20,60 20,70" stroke="#fff" strokeWidth="8" strokeLinecap="round" />
             <path className="astro-arm-r" fill="#fff" d="M70,55 Q80,60 80,40" stroke="#fff" strokeWidth="8" strokeLinecap="round" />
             <circle className="hand-r" cx="80" cy="40" r="5" fill="#ddd" />
          </svg>
        </div>

        <h2 className="space-title">Houston, we have a problem.</h2>
        <p className="space-text">
          The page you are looking for has drifted into deep space.<br />
          It seems you've ventured too far from the known universe.
        </p>

        <Link to="/" className="mission-control-btn">
          🚀 Return to Mission Control
        </Link>
      </div>
    </div>
  );
};

export default NotFound;